(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-submenu"] && !Shopify.designMode) return;
  try {
    (() => {
    const rootSelector = '[data-collection-submenu]';

    const updateNav = (root) => {
      const track = root.querySelector('[data-collection-submenu-track]');
      const prev = root.querySelector('[data-collection-submenu-prev]');
      const next = root.querySelector('[data-collection-submenu-next]');

      if (!track || !prev || !next) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      const hasOverflow = maxScroll > 2;

      root.classList.toggle('collection-submenu--has-overflow', hasOverflow);

      if (!hasOverflow) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }

      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= maxScroll - 2;
    };

    const init = (root) => {
      if (root.dataset.submenuReady === 'true') return;
      root.dataset.submenuReady = 'true';

      const track = root.querySelector('[data-collection-submenu-track]');
      const prev = root.querySelector('[data-collection-submenu-prev]');
      const next = root.querySelector('[data-collection-submenu-next]');

      if (!track || !prev || !next) return;

      const scrollByAmount = () => Math.max(track.clientWidth * 0.75, 120);

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', () => updateNav(root), { passive: true });
      window.addEventListener('resize', () => updateNav(root));

      updateNav(root);
    };

    const initAll = () => {
      document.querySelectorAll(rootSelector).forEach(init);
    };

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector(rootSelector);
      if (root) {
        root.dataset.submenuReady = 'false';
        init(root);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
